import ActionLogExtendedListViewController from '../../../store/action_log/controllers/extended-list-controller';

angular
    .module('festzelt-os.modules.action_log')
    .controller('ActionLogExtendedListViewController', [
        'ActionLogEntry',
        '$injector',
        '$scope',
        (ActionLogEntry, $injector, $scope) => new ActionLogExtendedListViewController(ActionLogEntry, $injector, $scope)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/action_log/controller/extended-listview.js